// extracted by mini-css-extract-plugin
export default {"menu":"MultipleSelectListbox_menu__jT+RY"};